import { SkeletonBox } from '@practium/ui';
import styles from './BillingTable.module.css';

const ROWS = 10;

const COL_WIDTHS = ['6rem', '5rem', '6.5rem', '4rem', '4rem', '4rem', '4.5rem', '3.5rem', '4.5rem', '4rem'];

export const BillingTableSkeleton = () => (
	<div className={styles.tableWrapper}>
		<table className={styles.table}>
			<thead className={styles.thead}>
				<tr>
					{COL_WIDTHS.map((w, i) => (
						<th key={i}>
							<SkeletonBox height="0.75rem" width={w} />
						</th>
					))}
				</tr>
			</thead>
			<tbody className={styles.tbody}>
				{Array.from({ length: ROWS }, (_, row) => (
					<tr key={row}>
						{COL_WIDTHS.map((w, col) => (
							<td key={col}>
								<SkeletonBox height="0.875rem" width={w} />
							</td>
						))}
					</tr>
				))}
			</tbody>
		</table>
	</div>
);
